import { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import "./editModal.css";

export default function EditModal({ item, onClose, onSave }) {
  const [formData, setFormData] = useState({ ...item });
  const [newImage, setNewImage] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "order" ? Number(value) : value,
    }));
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    try {
      let imageUrl = formData.imageUrl;

      if (newImage) {
        const storageRef = ref(
          storage,
          `banners/${Date.now()}_${newImage.name}`
        );
        const snapshot = await uploadBytes(storageRef, newImage);
        imageUrl = await getDownloadURL(snapshot.ref);
      }

      const updatedData = {
        ...formData,
        imageUrl,
      };

      onSave(updatedData);
    } catch (error) {
      console.error("Image upload error:", error);
      alert("Failed to upload image.");
    }

    setUploading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Edit Banner</h2>
        <form onSubmit={handleSubmit}>
          <img
            src={formData.imageUrl}
            alt="Current"
            style={{
              width: "70px",
              marginBottom: "1rem",
              borderRadius: "8px",
            }}
          />
          <label>Replace Image (optional)</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />

          <input
            type="text"
            name="title"
            placeholder="Title"
            value={formData.title}
            onChange={handleChange}
          />
          <input
            type="text"
            name="caption"
            placeholder="Caption"
            value={formData.caption}
            onChange={handleChange}
          />
          <input
            type="text"
            name="title2"
            placeholder="Another Caption"
            value={formData.title2}
            onChange={handleChange}
          />
          <input
            type="text"
            name="buttonText"
            placeholder="Button Text"
            value={formData.buttonText}
            onChange={handleChange}
          />
          <input
            type="text"
            name="buttonLink"
            placeholder="Button Link"
            value={formData.buttonLink}
            onChange={handleChange}
          />
          <input
            type="number"
            name="order"
            placeholder="Order"
            value={formData.order}
            onChange={handleChange}
          />

          <div className="modal-actions">
            <button type="submit" className="save-btn" disabled={uploading}>
              {uploading ? "Saving..." : "Save"}
            </button>
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
